import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default (props: any) => (
  <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 4L16 16M16 4L4 16" stroke={props.iconcolor || 'currentColor'} strokeWidth="1.6" strokeLinecap="round" />
  </SvgIcon>
);
